module.exports = __webpack_public_path__ + "img/layout-7_1.525180b3.png";